module.exports = __webpack_public_path__ + "static/media/login.e29a070a.png";